import React from 'react';

import css from './IdentityLoader.module.scss';
import layoutCSS from '../../Layout/Layout.module.scss';

const IdentityLoader = () => (
  <div className={layoutCSS.layoutWrapper}>
    <h1 data-e2e={`identity-loader-header`}>
      Hold tight! We’re verifying your information.
    </h1>
    <div
      className={css.loadingContainer}
      data-e2e="identity-loading-screen"
      data-testid="identity-loader"
    >
      <img
        className={css.loadingImage}
        src={`/static/prove-loader.gif`}
        alt={`Verifying Information`}
      />
    </div>
  </div>
);

export default IdentityLoader;
